import React, { Component } from "react";
import { connect } from "react-redux";
import ImmutablePropTypes from "react-immutable-proptypes";
import Immutable from "immutable";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Features } from "resourceModels/Client";
import tinycolor from "tinycolor2";
import { Client } from "resourceModels";
import { updateOne } from "actions/resources";
import { getResource } from "selectors/resources";
import Avatar from "components/Common/Avatar";
import ChatLogItem from "components/Common/ChatLogItem";
import { RadioButton } from "components/Common/RadioButton";
import RadioButtons from "components/Common/RadioButtons";
import ColorInput from "components/Common/ColorInput";
import Checkbox from "components/Common/Checkbox";
import SvgIcon from "components/Common/SvgIcon";
import MediaUploader from "components/Common/MediaUploader";
import colors from "stylesheets/utilities/colors.scss";
import "./style.scss";
import * as S from "./styles";

const options = [
  {
    value: "stacked",
    title: "Stacked"
  },
  {
    value: "carousel",
    title: "Carousel"
  }
];

const BLOCK_NAME = "SettingsPlatformChatModalChatWindow";

class SettingsPlatformChatModalChatWindow extends Component {
  /**
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.handleUpdateTint = this.handleUpdateTint.bind(this);
    this.handleUpdateDesktopButtonLayout = this.handleUpdateDesktopButtonLayout.bind(this);
    this.handleUpdateMobileButtonLayout = this.handleUpdateMobileButtonLayout.bind(this);
    this.handleUpdateUseLetterOption = this.handleUpdateUseLetterOption.bind(this);
    this.handleUpdateUseIconOption = this.handleUpdateUseIconOption.bind(this);
    this.handleUpdateBotAvatarLetter = this.handleUpdateBotAvatarLetter.bind(this);
    this.handleUpdateBotAvatarImage = this.handleUpdateBotAvatarImage.bind(this);
    this.handleUpdateBranded = this.handleUpdateBranded.bind(this);
    this.handleUpdatePrivacy = this.handleUpdatePrivacy.bind(this);
    this.handleUpdatePrivacyLink = this.handleUpdatePrivacyLink.bind(this);
    this.handleUpdateLiveAgentAvatar = this.handleUpdateLiveAgentAvatar.bind(this);
    this.handleUpdateAgentAvatarImage = this.handleUpdateAgentAvatarImage.bind(this);
  }

  /**
   * Getters
   */

  /**
   * @returns {Boolean}
   */
  get isClientTintDark() {
    const {
      /** @type Client */
      client
    } = this.props;

    return tinycolor(client.tint).isDark();
  }

  /**
   * Handlers
   */

  /**
   * @param {String} tint
   */
  handleUpdateTint(tint) {
    this.updateClient({ tint });
  }

  /**
   * @param {String} layout
   */
  handleUpdateDesktopButtonLayout(layout) {
    const { platformType, updatePlatform } = this.props;
    updatePlatform(platformType, { buttonLayoutDesktop: layout });
  }

  /**
   * @param {String} layout
   */
  handleUpdateMobileButtonLayout(layout) {
    const { platformType, updatePlatform } = this.props;
    updatePlatform(platformType, { buttonLayoutMobile: layout });
  }

  /**
   * @param {String} value
   */
  handleUpdateLiveAgentAvatar(value) {
    const { client } = this.props;

    this.updateClient({
      agentAvatar: client.agentAvatar.set("default", value === "default")
    });
  }

  /**
   * @param {Object} url
   */
  handleUpdateAgentAvatarImage(url) {
    const { client } = this.props;

    this.updateClient({
      agentAvatar: client.agentAvatar.set("image", url)
    });
  }

  /** */
  handleUpdateUseLetterOption() {
    const { client } = this.props;

    this.updateClient({
      avatar: client.avatar.set("useLetter", true)
    });
  }

  /** */
  handleUpdateUseIconOption() {
    const { client } = this.props;

    this.updateClient({
      avatar: client.avatar.set("useLetter", false)
    });
  }

  /**
   * @param {Object} event
   */
  handleUpdateBotAvatarLetter(event) {
    const { client } = this.props;

    this.updateClient({
      avatar: client.avatar.set("letter", event.target.value.toUpperCase())
    });
  }

  /**
   * @param {Object} url
   */
  handleUpdateBotAvatarImage(url) {
    const { client } = this.props;

    this.updateClient({
      avatar: client.avatar.set("image", url)
    });
  }

  /** */
  handleUpdateBranded() {
    const { platformType, platform, updatePlatform } = this.props;
    const showLogo = !platform.getIn(["record", "showLogo"]);
    updatePlatform(platformType, { showLogo });
  }

  /** */
  handleUpdatePrivacy() {
    const { platformType, platform, updatePlatform } = this.props;
    const privacy = !platform.getIn(["record", "privacy"]);
    updatePlatform(platformType, { privacy });
  }

  /**
   * @param {Event} event
   */
  handleUpdatePrivacyLink(event) {
    const { platformType, updatePlatform } = this.props;
    const privacyLink = event.target.value;
    updatePlatform(platformType, { privacyLink });
  }

  /**
   * @param {Object} data
   */
  updateClient(data) {
    const { client, updateClient } = this.props;
    updateClient(client.id, data);
  }

  /**
   * Render the default conversation
   * @returns {React.Element} conversation
   */
  renderDefaultConvo() {
    const {
      /** @type Client */
      client
    } = this.props;

    // the bot avatar to display next to messages
    const botAvatar = (
      <div className={`${BLOCK_NAME}__preview__group__avatar`}>
        <Avatar
          isLarge
          client={client}
          clientToken="123"
          customClassName="BotIconList__avatar"
        />
      </div>
    );

    return (
      <>
        <div
          className={classnames(
            "SettingsPlatformChatModalChatWindow__preview__group", {
              "SettingsPlatformChatModalChatWindow__preview__group--bot": client.hasFeature(Features.BOT_ROUTING)
            }
          )}
        >
          {client.hasFeature(Features.BOT_ROUTING) && botAvatar}

          <ChatLogItem isFromUs>
            Hi! I’m a Bot. <span role="img" aria-label="wave">👋</span> How can I help you?
          </ChatLogItem>
        </div>

        <div className="SettingsPlatformChatModalChatWindow__preview__group">
          <ChatLogItem>
            What is Ada’s Mission
          </ChatLogItem>
        </div>

        <div
          className={classnames(
            "SettingsPlatformChatModalChatWindow__preview__group", {
              "SettingsPlatformChatModalChatWindow__preview__group--bot": client.hasFeature(Features.BOT_ROUTING)
            }
          )}
        >
          {client.hasFeature(Features.BOT_ROUTING) && botAvatar}

          <ChatLogItem isFromUs>
            We&#39;re on a mission to give back time through incredible customer service.
          </ChatLogItem>
        </div>
      </>
    );
  }

  /**
   * Render the default conversation
   * @returns {ReactElement} conversation
   */
  renderLiveAgentConvo() {
    const {
      /** @type Client */
      client
    } = this.props;

    // the bot avatar to display next to messages
    const botAvatar = (
      <div className={`${BLOCK_NAME}__preview__group__avatar`}>
        <Avatar
          isLarge
          client={client}
          clientToken="123"
          customClassName="BotIconList__avatar"
        />
      </div>
    );

    const agentAvatar = (
      <div className="SettingsPlatformChatModalChatWindow__preview__group__avatar">
        <Avatar
          isLarge
          client={client}
          clientToken="123"
          customClassName="BotIconList__avatar"
          source="agent"
        />
      </div>
    );

    return (
      <>
        <div className="
          SettingsPlatformChatModalChatWindow__preview__group
          SettingsPlatformChatModalChatWindow__preview__group--agent
          "
        >
          {agentAvatar}

          <ChatLogItem isFromUs>
            Great, if you need anything else please reach out again.
          </ChatLogItem>
        </div>

        <div className="SettingsPlatformChatModalChatWindow__preview__group">
          <ChatLogItem>
            Thank you.
          </ChatLogItem>
        </div>

        <div className="
            SettingsPlatformChatModalChatWindow__preview__group
            SettingsPlatformChatModalChatWindow__preview__group--presence
          "
        >
          Agent has left the chat
        </div>

        <div className="
          SettingsPlatformChatModalChatWindow__preview__group
          SettingsPlatformChatModalChatWindow__preview__group--bot
          "
        >
          {botAvatar}

          <ChatLogItem isFromUs>
            Welcome back <span role="img" aria-label="wave">👋</span>!
            Are there any other topics that you need more help with?
          </ChatLogItem>
        </div>
      </>
    );
  }

  /**
   * @returns {React.Element} preview
   */
  renderPreview() {
    const {
      /** @type Client */
      client,
      platform
    } = this.props;

    const botRoutingEnabled = client.hasFeature(Features.BOT_ROUTING);
    const liveAgentEnabled = client.hasLiveAgentFeature;
    const isCarousel = platform.getIn(["record", "buttonLayoutDesktop"]) === "carousel";

    return (
      <>
        {liveAgentEnabled ? this.renderLiveAgentConvo() : this.renderDefaultConvo()}
        <S.PreviewQuickReplyButtons
          isCarousel={isCarousel}
          noAvatars={!botRoutingEnabled}
        >
          {!liveAgentEnabled && (
            <S.PreviewQuickReplyButton
              isCarousel={isCarousel}
              color={client.tint}
              type="button"
            >
              Let’s get started
            </S.PreviewQuickReplyButton>
          )}
          <S.PreviewQuickReplyButton
            isCarousel={isCarousel}
            color={client.tint}
            type="button"
          >
            How it works?
          </S.PreviewQuickReplyButton>
          <S.PreviewQuickReplyButton
            isCarousel={isCarousel}
            color={client.tint}
            type="button"
          >
            What is Ada’s Mission?
          </S.PreviewQuickReplyButton>
        </S.PreviewQuickReplyButtons>

        <div>
          <div className="SettingsPlatformChatModalChatWindow__preview__message-input">
            <div className="SettingsPlatformChatModalChatWindow__preview__message-input__input">Ask me something...</div>
            <div
              className="SettingsPlatformChatModalChatWindow__preview__message-input__submit-button"
              style={{
                backgroundColor: client.tint
              }}
            >
              <SvgIcon
                icon="ArrowUp"
                fillColor={colors.colorWhite}
                height={20}
              />
            </div>
          </div>

          {platform.getIn(["record", "showLogo"]) && (
            <p className={`${BLOCK_NAME}__preview__branded-link`}>
              This bot was built on Ada
            </p>
          )}
        </div>
      </>
    );
  }

  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      /** @type Client */
      client,
      platform
    } = this.props;

    const botAvatar = client.avatar;
    const botAvatarImage = botAvatar.get("image");
    const agentAvatarDefault = client.agentAvatar.get("default");
    const agentAvatarImage = client.agentAvatar.get("image");

    return (
      <div className="SettingsPlatformChatModalChatWindow">
        <div className="SettingsPlatformChatModalChatWindow__settings Modal__content">
          <section className="SettingsPlatformChatModalChatWindow__settings__section">
            <label
              htmlFor="tintSelecter"
              className="g-input__label g-input__label--no-description"
            >
              Primary Color
            </label>
            <div className="SettingsPlatformChatModalChatWindow__settings__section__input-color">
              <ColorInput
                value={client.tint}
                handleChange={this.handleUpdateTint}
              />
            </div>
          </section>

          <section className="SettingsPlatformChatModalChatWindow__settings__section">
            <div
              className="g-input__label g-input__label--no-description"
            >
              Quick Reply Buttons
            </div>
            <div className="SettingsPlatformChatModalChatWindow__settings__qr-options">
              <div className="SettingsPlatformChatModalChatWindow__settings__qr-options__subsection">
                <div className="SettingsPlatformChatModalChatWindow__settings__qr-options__subsection__label">Desktop</div>
                <RadioButtons
                  name="buttonLayoutDesktop"
                  uniqueIdentifier="buttonLayoutDesktop"
                  options={options}
                  checked={platform.getIn(["record", "buttonLayoutDesktop"])}
                  onClick={this.handleUpdateDesktopButtonLayout}
                />
              </div>
              <div className="SettingsPlatformChatModalChatWindow__settings__qr-options__subsection">
                <div className="SettingsPlatformChatModalChatWindow__settings__qr-options__subsection__label">Mobile</div>
                <RadioButtons
                  name="buttonLayoutMobile"
                  uniqueIdentifier="buttonLayoutMobile"
                  options={options}
                  checked={platform.getIn(["record", "buttonLayoutMobile"])}
                  onClick={this.handleUpdateMobileButtonLayout}
                />
              </div>
            </div>
          </section>
          {/* Disabling until feature is ready to ship */}
          {client.hasLiveAgentFeature &&
            (
              <section className="SettingsPlatformChatModalChatWindow__settings__section">
                <div
                  className="g-input__label g-input__label--no-description"
                >
                  Live Agent Avatar
                </div>
                <RadioButtons
                  name="liveAgentAvatar"
                  uniqueIdentifier="liveAgentAvatar"
                  options={[
                    {
                      value: "default",
                      title: "Default"
                    },
                    {
                      value: "custom",
                      title: "Custom Icon"
                    }
                  ]}
                  checked={agentAvatarDefault ? "default" : "custom"}
                  onClick={this.handleUpdateLiveAgentAvatar}
                />
                <div
                  className={classnames(
                    "SettingsPlatformChatModalChatWindow__settings__section__text-input", {
                      "SettingsPlatformChatModalChatWindow__settings__section__text-input--hidden": agentAvatarDefault
                    }
                  )}
                >
                  <MediaUploader
                    {...this.props}
                    id="Live_Agent_Image_Uploader"
                    name="Live_Agent_Image_Uploader"
                    onChange={this.handleUpdateAgentAvatarImage}
                    urlPath={Immutable.Map({ image: agentAvatarImage })}
                    urlField="image"
                    placeholder="https://static.ada.support/my-picture.svg"
                    endpoint="/images/"
                    uploadIcon="Upload"
                    notValid={client.invalidFields.includes("agentAvatarImage")}
                  />
                </div>
              </section>
            )}

          <section className="SettingsPlatformChatModalChatWindow__settings__section">
            <div
              className="g-input__label g-input__label--no-description"
            >
              Bot Avatar
            </div>
            <div className={`${BLOCK_NAME}__settings__section__text-input__radio`}>
              <RadioButton
                id="avatar_text_option"
                name="avatar_text_option"
                checked={botAvatar.get("useLetter")}
                onClick={this.handleUpdateUseLetterOption}
                label="Letter"
              />
            </div>
            <div
              className={classnames(
                `${BLOCK_NAME}__settings__section__text-input`, {
                  [`${BLOCK_NAME}__settings__section__text-input--hidden`]: !botAvatar.get("useLetter")
                }
              )}
            >
              <input
                className={classnames(
                  "g-input SettingsPlatformChatModalChatWindow__settings__section__text-input__letter-input",
                  { "g-input--invalid": client.invalidFields.includes("botAvatarLetter") }
                )}
                type="text"
                placeholder="A"
                maxLength="1"
                value={botAvatar.get("letter")}
                onChange={this.handleUpdateBotAvatarLetter}
              />
            </div>
            <div
              className={classnames(
                "SettingsPlatformChatModalChatWindow__settings__section__text-input__text", {
                  "SettingsPlatformChatModalChatWindow__settings__section__text-input__text--hidden": !botAvatar.get("useLetter")
                }
              )}
            >
              1 letter max
            </div>
            <div className={`${BLOCK_NAME}__settings__section__text-input__radio`}>
              <RadioButton
                id="avatar_picture_option"
                name="avatar_picture_option"
                checked={!botAvatar.get("useLetter")}
                onClick={this.handleUpdateUseIconOption}
                label="Custom Icon"
              />
            </div>
            <div
              className={classnames(
                `${BLOCK_NAME}__settings__section__text-input`, {
                  [`${BLOCK_NAME}__settings__section__text-input--hidden`]: botAvatar.get("useLetter")
                }
              )}
            >
              <MediaUploader
                {...this.props}
                id="Bot_Image_Uploader"
                name="Bot_Image_Uploader"
                onChange={this.handleUpdateBotAvatarImage}
                urlPath={Immutable.Map({ image: botAvatarImage })}
                urlField="image"
                acceptTypes=".svg"
                placeholder="https://static.ada.support/my-picture.svg"
                endpoint="/images/"
                uploadIcon="Upload"
                notValid={client.invalidFields.includes("botAvatarImage")}
              />
            </div>
            <div className={classnames(
              "SettingsPlatformChatModalChatWindow__settings__section__text-input__text", {
                "SettingsPlatformChatModalChatWindow__settings__section__text-input__text--hidden": botAvatar.get("useLetter")
              }
            )}
            >
              Upload SVGs only.
            </div>
          </section>
          <section className="SettingsPlatformChatModalChatWindow__settings__section">
            {client.hasFeature(Features.NO_BRANDING) && (
              <div className="SettingsPlatformChatModalChatWindow__settings__section__switch-section">
                <label
                  htmlFor="show-logo-toggle"
                  className="g-input__label g-input__label--no-description"
                >
                  Branded
                </label>
                <Checkbox
                  id="show-logo-toggle"
                  checked={platform.getIn(["record", "showLogo"])}
                  handleToggle={this.handleUpdateBranded}
                  isSwitch
                />
              </div>
            )}
            <div className="SettingsPlatformChatModalChatWindow__settings__section__switch-section">
              <label
                htmlFor="privacy-toggle"
                className="g-input__label g-input__label--no-description"
              >
                Privacy
              </label>
              <Checkbox
                id="privacy-toggle"
                checked={platform.getIn(["record", "privacy"])}
                handleToggle={this.handleUpdatePrivacy}
                isSwitch
              />
            </div>
            <input
              className="g-input SettingsPlatformChatModalChatWindow__settings__section__switch-section__input"
              onChange={this.handleUpdatePrivacyLink}
              value={platform.getIn(["record", "privacyLink"])}
              placeholder="https://ada.support/privacy/"
            />
            <p className="Modal__section__sub-section__description">Show privacy link in the chat window.</p>
          </section>
        </div>
        <div className="SettingsPlatformChatModalChatWindow__preview Modal__content">
          {this.renderPreview()}
        </div>
      </div>
    );
  }
}

SettingsPlatformChatModalChatWindow.propTypes = {
  platformType: PropTypes.string.isRequired,
  platform: ImmutablePropTypes.map.isRequired,
  updatePlatform: PropTypes.func.isRequired,

  client: PropTypes.instanceOf(Client).isRequired,
  updateClient: PropTypes.func.isRequired
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapStateToProps(state) {
  return {
    client: getResource(state, "client")
  };
}

/**
 * @param {Function} dispatch
 * @returns {Object.<Function>}
 */
function mapDispatchToProps(dispatch) {
  return {
    updateClient: (id, data) => dispatch(updateOne("client", id, data))
  };
}

const Connector = connect(mapStateToProps, mapDispatchToProps)(SettingsPlatformChatModalChatWindow);

Connector.propTypes = {
  platformType: PropTypes.string.isRequired,
  platform: ImmutablePropTypes.map.isRequired,
  updatePlatform: PropTypes.func.isRequired
};

export default Connector;
